export const state = {
    page: 1,
    limit: 25
};

export const reducer = {
    setLimit(state, action) {
        if ('limit' in (state || {})) {
            state.limit = action?.payload;
        }
    },
    setPage(state, action) {
        if ('page' in (state || {})) {
            state.page = action?.payload;
        }
    },
    clearPagination(state) {
        if ('page' in (state || {})) {
            state.page = 1;
        }
        if ('limit' in (state || {})) {
            state.limit = 25;
        }
    }
};
